import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, TextField, CircularProgress, Alert } from "@mui/material";
import { styled, useTheme } from "@mui/system";
import { Card } from "@mui/material";
// import CustomButton from "./CustomButton";
import CustomButton from "components/CustomButton";

const SearchCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: "8px",
  marginBottom: theme.spacing(0),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  height: "300px",
  overflow: "auto",
}));

const NoResultsMessage = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  backgroundColor: theme.palette.grey[100],
  borderRadius: "8px",
  textAlign: "center",
  fontStyle: "italic",
  padding: theme.spacing(1),
}));

const VectorSearch = ({
  searchQuery,
  setSearchQuery,
  handleSearch,
  isLoading,
  error,
  setError,
  description,
}) => {
  const theme = useTheme();

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <SearchCard>
      <Typography variant="h6" gutterBottom>
        Vector Search
      </Typography>
      <Box width="100%" minHeight="200px" display="flex" flexDirection="column">
        <TextField
          label="Search"
          variant="outlined"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyPress={handleKeyPress}
          fullWidth
          sx={{ mb: 2 }}
        />
        <CustomButton
          variant="contained"
          color="secondary"
          onClick={handleSearch}
          disabled={isLoading}
          sx={{
            marginTop: theme.spacing(2),
            width: "120px",
            height: "36px",
          }}
        >
          {isLoading ? <CircularProgress size={20} color="inherit" /> : "Search"}
        </CustomButton>
        {error && (
          <Alert severity="error" onClose={() => setError(false)} sx={{ mt: 2 }}>
            Something went wrong. Please try again.
          </Alert>
        )}
        {description && <NoResultsMessage variant="body1">{description}</NoResultsMessage>}
      </Box>
    </SearchCard>
  );
};

VectorSearch.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  setSearchQuery: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  setError: PropTypes.func.isRequired,
  description: PropTypes.string,
};

export default VectorSearch;
